import fetch from "isomorphic-fetch";
import { ApolloClient, ApolloClientOptions, ApolloLink, createHttpLink, from, InMemoryCache } from "@apollo/client";
import { AppConfig } from "@ct-react/core";
import { Locale } from "@ct-react/locale";

const buildConsumerMiddleWare = (appName: string, locale?: Locale): ApolloLink => {
  return new ApolloLink((operation, forward) => {
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        "GQL-Consumer-AppName": appName,
        ...(!!locale) && { "GQL-Consumer-Lang": locale.basename }
      }
    }));
    return forward(operation);
  });
}

const buildApolloClient = (ctx: AppConfig, ssrMode: boolean = false, locale?: Locale, restoringCache?: string) => {
  const cache = new InMemoryCache();
  if (!!restoringCache) cache.restore(JSON.parse(restoringCache));

  return new ApolloClient({
    ssrMode,
    connectToDevTools: !ssrMode && ctx.env === "development",
    link: from([
      buildConsumerMiddleWare(ctx.id, locale),
      createHttpLink({ uri: ctx.gqlClientUrl, fetch })
    ]),
    cache
  } as unknown as ApolloClientOptions<InMemoryCache>);
}

export default buildApolloClient;
